export const getServerOriginSelector = state => state.server.origin
